<template>
  <div v-if="data.courseWare.length > 0">
    <div v-if="data.courseWare.length > 0" class="classes-ware-files">
      <div class="classes-ware-file" v-for="(item, index) in data.courseWare" :key="index">
        <div
          class="classes-ware-file_icon"
          :class="{ ['classes-ware-file_icon-' + item.type]: true }"
        ></div>
        <div class="classes-ware-file_name" @click="onPreview(item)">
          {{ item.ware_name }}
        </div>
        <div v-if="item.ware_url" class="classes-ware-file_download" @click="onFileClick(item)">
          <img
            class="classes-ware-file_download-icon"
            src="@/assets/images/classes/download@2x.png"
          />
          <span>下载</span>
        </div>
      </div>
    </div>
  </div>
  <EmptyNew v-else title="暂无课件"></EmptyNew>
</template>
<script>
import EmptyNew from '@/components/EmptyNew.vue';

export default {
  name: 'MemberClassesWare',
  components: { EmptyNew },
  data() {
    return {
      id: this.$route.params.id,
      classifyId: 0,
      data: {
        classify: [],
        courseWare: [],
      },
      records: [],
    };
  },
  async created() {
    await this.getChildren();
  },
  methods: {
    async getChildren() {
      let data = await this.$http.get('/api/app/user/classCourseWare/' + this.id + '/');
      data.courseWare.forEach((f) => {
        if (
          /\.(mp3|wav|wma|aac|flac|m4a|oga|opus|mp4|3gp|mpg|mpeg|3g2|avi|flv|wmv|h264|m4v|mj2|mov|ogg|ogv|rm|rmvb|qt|webm)$/i.test(
            f.ware_url,
          )
        ) {
          f.type = 'video';
        } else if (/\.(doc|docx)$/i.test(f.ware_url)) {
          f.type = 'word';
        } else if (/\.(xls|xlsx)$/i.test(f.ware_url)) {
          f.type = 'excel';
        } else if (/\.(pdf)$/i.test(f.ware_url)) {
          f.type = 'pdf';
        } else if (/\.(ppt|pptx)$/i.test(f.ware_url)) {
          f.type = 'ppt';
        } else if (/\.(zip)$/i.test(f.ware_url)) {
          f.type = 'zip';
        } else {
          f.type = 'file';
        }
      });
      this.data = data;
    },
    onFileClick(file) {
      if (!file.ware_url) {
        return;
      }
      window.open(file.ware_url);
    },
    async onPreview(file) {
      if (file.ware_type == 3) {
        let data = await this.$http.get('/api/app/user/CourseWare/video/preview', {
          video_id: file.fid,
        });
        window.open(data[0].url);
      } else {
        let data = await this.$http.get('/api/app/user/CourseWare/preview', {
          fid: file.fid,
        });
        window.open(data);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.classes-ware-classifies {
  display: flex;
  padding: 0 0 32px 0;
}
.classes-ware-classify {
  width: 140px;
  height: 127px;
  position: relative;
  margin: 38px 62px 0 0;
  cursor: pointer;
  background: url('~@/assets/images/classes/folder@2x.png') center top/94px 77px no-repeat;
  text-align: center;
  position: relative;

  &:nth-child(6n) {
    margin-right: 0;
  }
}
.classes-ware-classify_name {
  height: 40px;
  line-height: 20px;
  position: absolute;
  width: 100%;
  bottom: 0;
}
.classes-ware-bread {
  padding: 18px 0 24px 24px;
  color: #999999;
  line-height: 22px;
}
.classes-ware-bread_bottom {
  padding-bottom: 0;
}
.classes-ware-bread_name {
  cursor: pointer;
}
.classes-ware-bread_current {
  color: #333;
  cursor: default;
}
.classes-ware-bread_line {
  margin: 0 10px;
}
.classes-ware-files {
  padding: 24px 24px 32px 24px;
}
.classes-ware-file {
  display: flex;
  align-items: center;
  border-radius: 4px;
  box-sizing: border-box;
  margin: 0 0 16px 0;
  padding-bottom: 16px;
  border-bottom: 1px solid #e7e7e7;

  &:last-child {
    margin-bottom: 0;
  }
}
.classes-ware-file_name {
  flex: 1;
  cursor: pointer;
  &:hover {
    color: $primary-color;
  }
}
.classes-ware-file_download {
  color: #999;
  cursor: pointer;
}
.classes-ware-file_download-icon {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}
.classes-ware-file_icon {
  width: 40px;
  height: 40px;
  background-size: 100% 100%;
  margin-right: 12px;
  flex-shrink: 0;
}
.classes-ware-file_icon-file {
  background-image: url('~@/assets/images/classes/file@2x.png');
}
.classes-ware-file_icon-excel {
  background-image: url('~@/assets/images/classes/excel@2x.png');
}
.classes-ware-file_icon-pdf {
  background-image: url('~@/assets/images/classes/pdf@2x.png');
}
.classes-ware-file_icon-ppt {
  background-image: url('~@/assets/images/classes/ppt@2x.png');
}
.classes-ware-file_icon-video {
  background-image: url('~@/assets/images/classes/video@2x.png');
}
.classes-ware-file_icon-word {
  background-image: url('~@/assets/images/classes/word@2x.png');
}
.classes-ware-file_icon-zip {
  background-image: url('~@/assets/images/classes/zip@2x.png');
}
</style>
